/**
 * AdminSignInSuccessView - Premium transition after admin sign-in.
 */

"use client";

import { useMemo } from "react";
import { useSearchParams } from "next/navigation";
import { PageTypeAdmin } from "@/lib/types";
import { getPostAuthRedirectPath } from "@/lib/utils/auth/postAuthRedirect";
import { getRoleDisplayName } from "@/lib/utils/roles";
import { AuthRedirectView } from "./AuthRedirectView";

interface AdminSignInSuccessViewProps {
  selectedRole?: string | null;
}

export const AdminSignInSuccessView = ({
  selectedRole,
}: AdminSignInSuccessViewProps = {}) => {
  const searchParams = useSearchParams();

  const redirectPath = useMemo(
    () => getPostAuthRedirectPath(searchParams.get("callbackUrl"), PageTypeAdmin.Dashboard),
    [searchParams],
  );

  const dashboardLabel = selectedRole
    ? `${getRoleDisplayName(selectedRole).toLowerCase()} dashboard`
    : "admin dashboard";

  return (
    <AuthRedirectView
      redirectPath={redirectPath}
      title="Welcome back"
      statusMessage={`Opening your ${dashboardLabel}…`}
      showLogo={false}
    />
  );
};
